// BreadcrumbRow — "Catalog › App" strip with folder + chevron icons.
// Mirrors `.freq-expanded__breadcrumb` in /Users/harry/Downloads/employee-portal/project/styles.css
// (lines 807–810) and the inline JSX in home.jsx (around line 113):
//   <i ti-folder /> {catalog} <i ti-chevron-right /> {app}
//
// Spec: inline-flex, gap 4px, font-size 12px (`xs`), color neutral.600.
// A leading folder icon precedes the first segment, and segments are joined
// with a chevron-right icon.

import { Box } from "@chakra-ui/react";
import { Fragment } from "react";
import { TbChevronRight, TbFolder } from "react-icons/tb";

export interface BreadcrumbRowProps {
  /** Ordered path segments. e.g. ["Catalog", "Slack"]. */
  segments: string[];
}

const BreadcrumbRow = ({ segments }: BreadcrumbRowProps) => {
  if (!segments?.length) return null;
  return (
    <Box
      display="inline-flex"
      alignItems="center"
      gap="2xs"
      fontSize="xs"
      color="neutral.600"
    >
      <Box as="span" display="inline-flex" alignItems="center" fontSize="12px">
        <TbFolder size={12} />
      </Box>
      {segments.map((seg, i) => (
        <Fragment key={`${seg}-${i}`}>
          {i > 0 && (
            <Box
              as="span"
              display="inline-flex"
              alignItems="center"
              fontSize="12px"
            >
              <TbChevronRight size={12} />
            </Box>
          )}
          <Box as="span">{seg}</Box>
        </Fragment>
      ))}
    </Box>
  );
};

BreadcrumbRow.displayName = "BreadcrumbRow";

export default BreadcrumbRow;
